module.exports = __webpack_public_path__ + "static/media/icon_data_top_main-4.fe3e25de.png";